// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Global: prevent double-scrollbars ───────────────────────────
   html & body must NOT scroll. The pageContent div in MainLayout.js
   is the single scroll container for all page content.
─────────────────────────────────────────────────────────────────── */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#root {
  height: 100%;
  overflow: hidden;
}

/* ── Profile dropdown (unchanged from your original) ────────────── */
.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.profile-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px;
}

.dropdown-content {
  position: absolute;
  top: 50px;
  right: 20px;
  background: #fff;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 180px;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  border: none;
  background: none;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/components/MainLayout.css"],"names":[],"mappings":"AAAA;;;qEAGqE;AACrE;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ── Global: prevent double-scrollbars ───────────────────────────\n   html & body must NOT scroll. The pageContent div in MainLayout.js\n   is the single scroll container for all page content.\n─────────────────────────────────────────────────────────────────── */\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n#root {\n  height: 100%;\n  overflow: hidden;\n}\n\n/* ── Profile dropdown (unchanged from your original) ────────────── */\n.profile-dropdown {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.profile-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px;\n}\n\n.dropdown-content {\n  position: absolute;\n  top: 50px;\n  right: 20px;\n  background: #fff;\n  padding: 12px;\n  border-radius: 6px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  min-width: 180px;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  text-align: left;\n  border: none;\n  background: none;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
